var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06734 8.21898C6.69199 8.04381 6.2457 8.2061 6.07054 8.58145C5.89537 8.9568 6.05766 9.40309 6.43301 9.57825L9.97157 11.2296C10.3066 11.386 10.6937 11.386 11.0288 11.2296L14.5674 9.57825C14.9427 9.40309 15.105 8.9568 14.9298 8.58145C14.7547 8.2061 14.3084 8.04381 13.933 8.21898L10.5002 9.82097L7.06734 8.21898Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 5.14453C5.17893 5.14453 3.5 6.82347 3.5 8.89453V12.3946C3.5 14.4657 5.17893 16.1446 7.25 16.1446H13.75C15.8211 16.1446 17.5 14.4657 17.5 12.3946V8.89453C17.5 6.82347 15.8211 5.14453 13.75 5.14453H7.25ZM5 8.89453C5 7.65189 6.00736 6.64453 7.25 6.64453H13.75C14.9926 6.64453 16 7.65189 16 8.89453V12.3946C16 13.6372 14.9926 14.6446 13.75 14.6446H7.25C6.00736 14.6446 5 13.6372 5 12.3946V8.89453Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.cdea8d4eb4823050af2b16c95563ef43.svg";
export { ForwardRef as ReactComponent };